const __WEBPACK_NAMESPACE_OBJECT__ = require("office-addin-dev-certs");